// Tipos de imagen permitidos a la hora de subir al servidor
export const ALLOWED_IMAGE_TYPES = [
    "image/png",
    "image/jpeg",
    "image/svg",
]